// a simple stub in case no i18n object was passed in
export default {
  t: (value: any) => value,
};
